import { Text } from '@vidahealth/vida-ui';

import { RadioDot, SelectableRow } from '@/modules/ui';

/** Private to QuickIntroMessagesScreen — a selectable preset intro message. */
export function MessageRow({
  label,
  selected,
  onPress,
  testID,
}: {
  label: string;
  selected: boolean;
  onPress: () => void;
  testID?: string;
}) {
  return (
    <SelectableRow
      isSelected={selected}
      onPress={onPress}
      selectionRole='radio'
      accessibilityLabel={label}
      className='py-6'
      testID={testID}
    >
      <RadioDot selected={selected} />
      <Text size='md' className='flex-1 font-body text-typography-900'>
        {label}
      </Text>
    </SelectableRow>
  );
}
